document.addEventListener('DOMContentLoaded', function(){

  function toggleAccordion() {
    this.classList.toggle("active");
    this.nextElementSibling.classList.toggle("active");
  }
 
  const items = document.querySelectorAll(".faq-wrapper .accordion a");
  items.forEach(item => item.addEventListener("click", toggleAccordion));
  

});
